import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function Attachment(props) {

    return (
        <div className="d-flex flex-sm-row align-items-center attachment-container">
            <span className="attachment-text">{props.name}</span>
            <FontAwesomeIcon className="attachment-icon" icon={"trash"} onClick={() => props.remove(props.name)}/>
        </div>
    )
}

export default Attachment;